module.exports = __webpack_public_path__ + "images/emoji/recycle.8523015ed17527e5f17c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/recycle.png
// module id = tTyd
// module chunks = 24